import delegate from "delegate";

export default {
  props: {
    sort: String,
    desc: Boolean
  },
  data() {
    return {
      sortTarget: this.sort || "",
      sortDesc: this.desc,
      sortDelegator: null,
    };
  },
  watch: {
    sourceList() {
      this.sortClonedList();
    },
  },
  methods: {
    sortClonedList() {
      if (!this.clonedList || !this.sortTarget) return;
      const sortTargetArr = this.sortTarget.split(",");

      this.clonedList.sort((a, b) => {
        let valA = sortTargetArr.reduce(getJoinReducer(a), "");
        let valB = sortTargetArr.reduce(getJoinReducer(b), "");
        if (/^\d*$/.test(valA) && /^\d*$/.test(valB)) {
          valA = parseInt(valA);
          valB = parseInt(valB);
        }
        if (this.sortDesc) return valA < valB ? 1 : -1;
        else return valA > valB ? 1 : -1;
      });
      function getJoinReducer(obj) {
        return (result, key) => {
          let val = _.get(obj, key);
          if (val === null) val = ".";
          return result + val;
        };
      }
    },
    resetSortButtons() {
      const className = `sorting_${this.sortDesc ? "desc" : "asc"}`;
      const targetButton = this.$el.querySelector(
        `[data-sort="${this.sortTarget}"]`
      );
      _.forEach(this.$el.querySelectorAll("[data-sort]"), (el) => {
        el.classList.remove("sorting_desc");
        el.classList.remove("sorting_asc");
      });
      if (targetButton)
        this.$el
          .querySelector(`[data-sort="${this.sortTarget}"]`)
          .classList.add(className);
    },
    onClickSortButton(e) {
      const target = e.target.dataset.sort;
      if (this.sortTarget === target) this.sortDesc = !this.sortDesc;
      this.sortTarget = target;
      this.sortClonedList();
      this.resetSortButtons();
    },
  },
  mounted() {
    _.forEach(this.$el.querySelectorAll("[data-sort]"), (el) =>
      el.classList.add("sorting")
    );
    this.sortDelegator = delegate(
      this.$el,
      "[data-sort]",
      "click",
      this.onClickSortButton
    );

    this.$on("resetState", () => {
      this.sortTarget = this.sort || "";
      this.sortDesc = this.desc;
      this.resetSortButtons();
    });
  },
  beforeDestroy() {
    this.sortDelegator.destroy();
  },
};
